export function ActionViewConstructor(services, callbacks, context) {

  let joint = services.joint;
  const { companyId, } = context;

  return joint.shapes.html.AbstractElementView.extend({

    template: [
      '<div class="html-element action">',
      '<div class="action-description"></div>',
      '<div class="answer-edit-container"><span class="glyphicon glyphicon-pencil answer-edit"></span></div>',
      '</div>'
    ].join(''),

    initialize: function () {
      joint.shapes.html.AbstractElementView.prototype.initialize.apply(this, arguments);

      // this.$box is initialized by the abstract superclass
      this.$box.find('.answer-edit').on('click', () => this.editAction());
    },

    editAction: function () {
      this.editActionPromise().then(result => {
        let parent = this.model.getAncestors()[0];
        let parentView = this.paper.findViewByModel(parent);

        if (result.type === 'delete') {
          this.model.remove.call(this.model);
          //we save the graph on remove cell event
        }
        else if (result.type === 'edit') {
          this.model.set('action', result.action);
          callbacks.updateSerializedGraph(this.model.graph);
        }
        //Resize needed for both editing and deleting
        parentView.resizeBox();
      })
    },

    editActionPromise: function () {
      let parent = this.model.getAncestors()[0];

      const alreadyHasATransferAction =
        parent.getEmbeddedCells().find(child => child.get('action') && child.get('action').type === 'transferAction') !== undefined;

      return services.$uibModal.open({
        animation: true,
        template: require('./chooseActionType.modal.html'),
        controller: 'chooseActionTypeController',
        resolve: {
          includeTransferAction: !alreadyHasATransferAction,
          action: angular.copy(this.model.get('action')),
          tagsGroups: services.ParametersFactory.getTagGroups(companyId).then(function (response) {
            return response.data;
          }),
          optins: () => context.optins,
          scenarioCustomEvents: () => context.botEvents,
          scenarioCustomEventsMap: () => context.botEventsMap,
          isCampaignScenario: () => context.isCampaignScenario,
          companyId: () => context.companyId,
          isEditAction: true,
        }
      }).result
    },

    updateBox: function () {
      joint.shapes.html.AbstractElementView.prototype.updateBox.apply(this, arguments);
      if (this.paper) {

        let actionDescription;

        switch (this.model.get('action').type) {
          case 'tagAction':
          case 'tagFromVariableAction':
            actionDescription = this.model.get('action').description;
            break;
          case 'transferAction':
            actionDescription = services.$translate.instant('parameters/quick_replies/details/transfer_action/transfer');
            break;
          case 'assignStaticVariableAction':
            const name = this.model.get('action').name || "";     // Avoid undefined in case of editing and then submitting empty assign variable action
            const value = this.model.get('action').value || "";
            actionDescription = name + " = " + value;
            break;
          case 'assignVariablesFromEndpointAction':
            const url = this.model.get('action').url || "";
            actionDescription = url.replace(/\//g, '\u200B/'); // allow browser to break lines before slashes
            break;
          case 'optinAction':
            const optinId = this.model.get('action').optin.id;
            const optin = context.optins.find(optin => optin.id == optinId);
            const optinName = optin ? optin.name : '';
            actionDescription = services.$translate.instant('parameters/quick_replies/details/new_action_popin/optin')
              + ' : ' + optinName;
            break;
          case 'optoutAction':
            const optinId2 = this.model.get('action').optin.id;
            const optin2 = context.optins.find(optin => optin.id === optinId2);
            const optinName2 = optin2 ? optin2.name : '';
            actionDescription = services.$translate.instant('parameters/quick_replies/details/new_action_popin/optout')
              + ' : ' + optinName2;
            break;
          case 'customEventAction': {
            const scenarioCustomEvent = this.model.get('action').scenarioCustomEvent;
            const { id } = scenarioCustomEvent;
            const label = context.botEventsMap.get(id)?.label;
            actionDescription = `${services.$translate.instant('parameters/quick_replies/details/new_action_popin/custom-event/drop-down-option')} : ${label}`;
            break;
          }
          case 'archiveAction':
            actionDescription = services.$translate.instant('parameters/quick_replies/details/new_action_popin/archive_action');
            break;
          case 'passThreadControlAction':
            actionDescription = services.$translate.instant('parameters/quick_replies/details/new_action_popin/pass_thread_control');
            break;
          case 'exportCapturedMessageContentAction':
            actionDescription = services.$translate.instant('parameters/quick_replies/details/new_action_popin/capture_message_content');
            break;
          case 'skipCare':
            actionDescription = services.$translate.instant('parameters/quick_replies/details/new_action_popin/skip_message_and_task_creation');
            break;
          default:
            break;
        }

        this.$box.find('.action-description').text(actionDescription);
      }
    },

  });
}
